var _path, _path2, _circle, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCardSuccess = function SvgCardSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.368 42.222A4.67 4.67 0 0 0 4.67 43.59h52.931a4.67 4.67 0 0 0 4.67-4.67V4.67A4.67 4.67 0 0 0 57.601 0H4.671A4.67 4.67 0 0 0 0 4.67v34.25a4.67 4.67 0 0 0 1.368 3.302Zm57.79-26.649V9.349H3.114v6.224h56.044ZM3.114 18.687h56.044V38.92a1.557 1.557 0 0 1-1.557 1.556H4.671a1.557 1.557 0 0 1-1.557-1.556V18.687ZM59.158 4.67v1.566H3.114V4.67A1.557 1.557 0 0 1 4.67 3.114h52.931a1.557 1.557 0 0 1 1.557 1.556ZM26.463 28.023H10.895a1.557 1.557 0 0 1 0-3.114h15.568a1.557 1.557 0 0 1 0 3.114Zm-15.568 6.22h9.34a1.556 1.556 0 1 0 0-3.114h-9.34a1.557 1.557 0 0 0 0 3.114Z",
    fill: "#5C7AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.379 26.9c-5.922 0-10.722 4.8-10.722 10.722s4.8 10.722 10.722 10.722S69.1 43.544 69.1 37.622c0-5.923-4.8-10.722-10.722-10.722Zm0 19.768c-5 0-9.046-4.047-9.046-9.046 0-5 4.047-9.046 9.046-9.046 5 0 9.046 4.047 9.046 9.046 0 5-4.047 9.046-9.046 9.046Z",
    fill: "#5C7AFF",
    stroke: "#5C7AFF",
    strokeWidth: 0.688
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.379,
    cy: 37.609,
    fill: "#fff",
    r: 9.081
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m56.74 40.347-2.605-2.754a.64.64 0 0 0-.947 0c-.26.274-.26.7 0 .975l3.08 3.245a.621.621 0 0 0 .471.212.658.658 0 0 0 .479-.209l6.165-6.496c.26-.274.26-.7 0-.975a.64.64 0 0 0-.947 0l-5.697 6.002Z",
    fill: "#03C8B0",
    stroke: "#03C8B0",
    strokeWidth: 0.3
  })));
};

export default SvgCardSuccess;